var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPetrol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.7773 0H22.5368C23.7314 0 24.7082 0.967322 24.7082 2.14943V16.5271C27.1777 16.6512 29.3037 17.2922 29.3037 20.5744V28.0272C29.3037 32.6161 35.5946 32.1634 35.5946 28.2894V19.1269L32.9241 16.5151V12.5294L28.3235 7.97519C27.2049 6.86787 28.9058 5.18441 30.0241 6.29173L38 14.1871V28.2898C38 35.298 26.899 35.7733 26.899 28.0275V20.5748C26.899 19.27 25.8274 18.9472 24.7082 18.8792V33.8017H26.6853C27.5811 33.8017 28.314 34.5269 28.314 35.4133V38H0V35.4133C0 34.5265 0.732627 33.8017 1.62803 33.8017H3.60518V2.14966C3.60518 0.967785 4.58283 0 5.7773 0ZM6.83252 2.99144H21.4816C21.9292 2.99144 22 3.23374 22 3.6765V15.5C22 15.944 21.9292 16.4809 21.4816 16.4809H6.83252C6.38496 16.4809 6.01847 16.1185 6.01847 15.6745V3.79697C6.01847 3.35452 6.38493 2.99144 6.83252 2.99144Z",
    fill: "#D6E3FC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5031 10.2437C16.7608 9.70679 17.4093 9.47123 17.9515 9.71758C18.4937 9.96393 18.7244 10.5989 18.4667 11.1358L17.6729 12.7899C17.7165 12.8259 17.7596 12.8626 17.8021 12.9C18.5993 13.6004 19.1676 14.5042 19.4492 15.4998H21.25C21.6642 15.4998 22 15.8355 22 16.2498C22 16.664 21.6642 16.9998 21.25 16.9998H6.75C6.33579 16.9998 6 16.664 6 16.2498C6 15.8355 6.33579 15.4998 6.75 15.4998H8.64505C8.92551 14.508 9.49073 13.6071 10.2834 12.9076C11.3127 11.9996 12.6519 11.4959 14.0413 11.4945C14.635 11.4939 15.2198 11.585 15.7753 11.7603L16.5031 10.2437ZM10.635 15.4998H17.4592C17.2493 15.0309 16.938 14.6067 16.5414 14.2583C15.8565 13.6565 14.9661 13.3238 14.0432 13.3247C13.1203 13.3256 12.2307 13.6602 11.547 14.2634C11.1532 14.6109 10.8439 15.0333 10.635 15.4998Z",
    fill: "#3081F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrol);
export default __webpack_public_path__ + "static/media/petrol.8c2513b384f3c9097f49d732c4f59f51.svg";
export { ForwardRef as ReactComponent };